import styled from 'styled-components';

export const FileListWrapper = styled.div<{ isOpened: boolean }>`
  display: flex;
  width: 100%;
  cursor: pointer;
  margin-bottom: 8px;

  & > div {
    color: ${({ theme, isOpened }) =>
      isOpened ? theme.colors.primary.blue : theme.colors.primary.grey};
  }

  svg {
    transition: none;
  }
`;

export const DocumentListWrapper = styled.div<{ isWidth: boolean }>`
  width: ${({ isWidth }) => (isWidth ? 'fit-content' : '100%')};
  .ant-btn {
    width: 209px;
    display: flex;
    justify-content: center;
  }
`;
